// extracted by mini-css-extract-plugin
module.exports = {"orbitPortalRoot":"OBTPortal_orbitPortalRoot__Q9MaC"};